import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/higuma-icon.png'
import _imports_1 from '../../assets/images/phonedown.svg'


const _hoisted_1 = { class: "talking-wrapper" }
const _hoisted_2 = { class: "talking-inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ひぐまさんアイコン",
  width: "100"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "ひぐまさん", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "talking-isTalking" }, [
  /*#__PURE__*/_createTextVNode(" 悩んでること言えたら"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 切ってね ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "とじる"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stopRecord()))
      }, _hoisted_7)
    ])
  ]))
}